export default {
  header: {
    language: 'EN',
    languageMb: 'EN',
    logout: "LOG OUT",
    rule: "RULE",
    viewRule: "VIEW RULE",
    shrinkMenuName: 'CATEGORY'
  },
  countdown: {
    begintime:'{name} will begin on',
    countDownText:"The countdown of {name} ",
    countDown:"Countdown"
  },
  end: {
    end:"Activity has ended.",
    order:"My Order"
  },
  common: {
    "0":{
      symbol: '{value}pt',
    },
    "1":{
      symbol: 'HKD{value}',
    },
    "2":{
      symbol: 'HKD{value}',
    },
    inCart:"In Cart",
    outdated:'Outdated',
    underway:'Underway',
    hide:'Hide',
    show:'Show',
    buyconfirm: "",
    confirmOrder: "Confirm Order",
    confirm: "Confirm",
    cancel: "Cancel",
    back: "Continue Shopping",
    agreement:'AGREEMENT',
    rule: 'RULES',
    warning:"Warning",
    pt:"Point",
    pt1:"Points",
    remainAmount:"Amount",
    agree:"Agree"
  },
  index: {
    empty: "No available event !"
  },
  login: {
    userName: 'userName',
    nameTip: 'Please input your company email address',
    password: 'password',
    passwordTip: 'Please input user password',
    login: 'Login',
    reg:'Register',
    sendMailSuccess:'Email has been sent,click the link to reset password',
    submit: 'Submit',
    reset:'Reset Password',
    resetSuccess:'Successfully reset password,Please login again',
    regSuccess:'Registration is done ! Please wait for the invitation for the staff sales',

    modifySuccess:'Successfully modify password,Please login again',
    equalPass:'Two passwords are not equal,please check',
    modify:'Modify Password',
    passwordResetTip:'Please input new password',
    passwordAgTip:'Please input new password again',
    passwordModifyTip:'Please input original password',
    passwordModifyAgTip:'Please input new password',
    forgetTip:'Please input your company Email address',
    forget:'Forgot Your Password?',
    errorEmail:'please fill in the correct Email address',
    invalidToken:"This link for password reset is invalid. If you've already changed your password through this link, please ignore this message;If you sent the password reset request for multiple times, please use the link in the last E-mail."
  },
  footer: {
    activity: 'Activity',
    classify: 'Category',
    cart: "Cart",
    my: 'My Profile'
  },
  goods: {
    specification: 'Specs',
    selectModel: 'selectModel',
    quantity: 'Qty',
    productDetails: 'Product Details',
    addCart: 'Add To Cart',
    buy: 'Buy',
    stock: 'Stock',
    exchange: "Redeem",
    minQuota: "Quota",
    sellOut: "Sold Out",
    productPrice: "Price",
    notFound: "Sorry, no related products were found~",
  },
  screen: {
    classify: 'classify',
    sort: 'sort',
    all: 'all',
    sortOne: 'Prices range from high to low',
    sortTwo: 'Prices range from low to high'
  },
  order: {
    cancelTip:"Are you sure to cancel this order?",
    empty:"No orders.",
    empty2:"No such orders.",
    myOrder: 'Orders',
    allOrder: 'All',
    noPayment: 'Unpaid',
    havePaid: 'Paid',
    shipped: 'Shipped',
    isAll: '',
    variable: ' Piece(s)',
    total: 'Total',
    subtotal:"Subtotal",
    cancelOrder: 'Cancel',
    cancelOrder1: 'Cancel Order',
    cancelSuccess:"The order has been cancelled successfully!",
    cancelFailed:"Failed, Please retry!",
    cancelBuy: 'Cancel',
    pay: 'Place your order',
    orderStatus: 'Order Status',
    consignee: 'Consignee',
    orderTime: 'Order Date',
    orderNumber: 'Order No.',
    canceled: "Cancelled",
    allOrders: "All Orders",
    orderDetail: "Order Details",
    successInfo:"Thank you, your order has been placed.",
    telephone: "Telephone",
    paymentMethod: "Payment Method",
    address: "Address",
    realPayment: "Actual Price",
    exportOrder: "Export Order",
    wechatPay:"WeChat Pay",
    pointPay:"Redeem by Point",
    pointPay1:"Point",
    outOfStock:"Out of stock items"
  },
  pointPay:{
    pointPay: "Redeem by Point",
    notenough: "You don't have enough point!",
    already: "This order has already finished!",
    use: "Redeem by Point",
    retry: "Please retry!",
    limit:"Redeem ASAP , order will be canceled after {limit} minutes",
    yourPt:'Your Total Point',
    consumedPt:'Need Point'
  },
  cart: {
    selected1:"Selected ",
    yourPoint:"You Have ",
    yourAmount:"Your Amount Limit",
    empty:"Cart Empty",
    confirmDelete: "Are you sure to remove this item from the shopping cart?",
    buy: "Buy",
    tip: 'Warning',
    confirm:"Proceed to Checkout",
    deleteTip: 'Are you sure to remove this item from the shopping cart?',
    cancel: 'Cancel',
    affirm: 'Submit',
    isAll: 'Select All',
    unSelect: 'Unselect All',
    settlement: 'Submit',
    selectNote: "Please select some items !",
    confirmOrder: "Each person can only submit {orderQty} order(s). Once you pay an order, the order can no longer been canceled or modified. Are you sure to submit the order?",
    continue: "Continue shopping",
    goHome: "Go shopping",
    delete: "Delete",
    selected: "{orderQty} Piece(s)"
  },
  global: {
    orderConfirm: "Please Confirm before Placing The Order",
    total: "Total",
    instant: "Confirm",
    spec: "Specification",
    model: "Model",
    noData: "No Data"
  },
  placeorder: {
    success: "Success！",
    lack: "One or more items in your order is now out of stock, we are adding rest of them to the order...",
    lackall: "All items in your order are now out of stock！",
    retry: "Oops！ Something went wrong, please retry!",
    globalamount: "This campaign has reach the limit of total amount!",
    perskuqty: "You have reached the limit of some product!",
    globalqty: "You cannot buy any more products!",
    typeqty: "You have reached the limit of category!",
    catqty: "You have reached the limit of category!",
    orderqty: "You cannot place any more order!",
    pointlack: "You don't have enough point!",
    over: "This event is finished!",
    personalamount:"You have reached your amount limit!"
  },
  cartMsg: {
    address: "Please select address",
    success: "Product added to shopping cart",
    lackall: "This item is now out of stock！",
    globalamount: "This campaign has reach the limit of total amount!",
    perskuqty: "You have reached the quota of this product!",
    globalqty: "You cannot buy any more products!",
    typeqty: "You have reached the quota of this type!",
    catqty: "You have reached the quota of this category!",
    orderqty: "You cannot place any more order!",
    pointlack: "You don't have enough point!",
    over: "This event is finished!",
    personalamount:"You have reached your amount limit!",
    0: "Product added to shopping cart",
    2: "This item is now out of stock！",
    3: "This item is now out of stock！",
    4: "This campaign has reach the quota of total amount!",
    5: "You have reached the quota of this product!",
    6: "You cannot buy any more products!",
    7: "You have reached the quota of this type!",
    8: "You have reached the quota of this category!",
    9: "You cannot place any more order!",
    10: "You don't have enough point!",
    11: "You have reached your amount limit!",
    12: "You remain amount is not enough!",
    retry: "Oops！ Something went wrong, please retry!",
  },
  session: {
    end: "This campaign is already finished.",
    start: "This campaign is not start yet.",
    text: "COUNTDOWN",
    countdown: "{days} Day(s) {hours}:{minutes}:{seconds}",
  },
  search: {
    info: "Please input keyword to search.",
    notfound: "Oops, we cannot find anything related to “{searchKeyWord}”",
    placeholder: "Search",
    history:"Search History"
  }
}




// WEBPACK FOOTER //
// ./src/locales/en.js